import { render, staticRenderFns } from "./CloseCardWizard.vue?vue&type=template&id=3cc9ece2&scoped=true&"
import script from "./CloseCardWizard.vue?vue&type=script&lang=js&"
export * from "./CloseCardWizard.vue?vue&type=script&lang=js&"
import style0 from "./CloseCardWizard.vue?vue&type=style&index=0&id=3cc9ece2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc9ece2",
  null
  
)

export default component.exports